export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
            <div>
              <h3 className="font-heading text-lg font-bold text-background-50 mb-3">51吃瓜网址</h3>
              <p className="text-foreground-400 text-sm leading-relaxed">
                全网最新吃瓜入口一站式导航平台，聚合51吃瓜网址新入口、51吃瓜官网全网最新等官方直达通道，每日更新防走失域名，确保用户一键访问不迷路。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-3">快速导航</h3>
              <ul className="space-y-2">
                <li><a href="#carousel" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">焦点专题</a></li>
                <li><a href="#updates" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">最新快讯</a></li>
                <li><a href="#ranking" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">热度榜单</a></li>
                <li><a href="#faq" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">常见问答</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-3">合作伙伴</h3>
              <p className="text-foreground-500 text-sm">更多合作伙伴即将入驻，敬请期待。</p>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-3">安全提示</h3>
              <p className="text-foreground-400 text-sm leading-relaxed">
                请认准51吃瓜网址官方入口与防走失域名，谨防仿冒网站。本站不存储任何用户数据，仅提供信息导航服务。
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 51吃瓜网址 - 全网最新吃瓜入口一站式导航
            </p>
            <p className="text-foreground-600 text-xs">
              本站为信息导航平台，内容来源于网络公开信息
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}